// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g3qM","content":"styles_content__3uZqK"};